import { render, staticRenderFns } from "./Gap.vue?vue&type=template&id=a71a898c&scoped=true"
import script from "./Gap.vue?vue&type=script&lang=js"
export * from "./Gap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71a898c",
  null
  
)

export default component.exports